<!-- PageSelectMenuSearch.vue -->
<template>
  <div>
    <input
      ref="input"
      v-model="localValue"
      :type="type"
      class="w-full h-full px-2"
      :placeholder="placeholder"
      v-bind="$attrs"
      @input="onInput"
      @focus="onFocus"
      @blur="onBlur"
    >
  </div>
</template>

<script>
export default {
  name: 'PageSelectMenuSearch',
  props: {
    value: {
      type: String,
      default: ''
    },
    autoFocus: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: 'search'
    },
    placeholder: {
      type: String,
      default: 'Type to search pages'
    }
  },
  data () {
    return {
      timer: null,
      localValue: this.value,
      isFocused: false
    }
  },
  watch: {
    // Only pull prop -> input when not focused (prevents clobbering)
    value (newVal) {
      if (!this.isFocused && newVal !== this.localValue) {
        this.localValue = newVal
      }
    }
  },
  mounted () {
    if (this.autoFocus) {
      setTimeout(() => {
        this.$refs.input && this.$refs.input.focus()
      }, 10)
    }
  },
  methods: {
    onFocus () {
      this.isFocused = true
    },
    onBlur () {
      this.isFocused = false
      this.$emit('input', this.localValue)
    },
    onInput () {
      const val = this.localValue
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.$emit('input', val)
        this.$emit('onSearch', val)
      }, 300)
    }
  }
}
</script>